export enum QueryVerb {
	AND = 'AND',
	OR = 'OR',
	NOT = 'NOT'
}
